import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appFormatDate]'
})
export class FormatDateDirective {

  constructor(public ngControl: NgControl) { }
  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }

  onInputChange(value, backspace){
   let myDate = new Date();
    if (value === "" || value === null || value instanceof Date) {
      return true;
  } else {
      var date = value;
      let matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(date);
      if (matches == null) return false;
      var d = parseInt(matches[2]);
      var m = parseInt(matches[1]) - 1;
      var y = parseInt(matches[3]);
      var composedDate = new Date(y, m, d);
      return composedDate.getDate() == d &&
          composedDate.getMonth() == m &&
          composedDate.getFullYear() == y;
  }
  if (value == null) return true;
  }
}

